export default __webpack_public_path__ + "static/media/pe.f5a2bea0.svg";